
import { Vue, Component } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Integrations extends Vue {
  grid = {};
  url = "/api/outlander/config/grid?rows=20";
  showFilter = false;
  filterUrl = "";
  page = 1;
  deleteConfirmed = false;
  on = null;
  date = null;

  kindList = [
    {
      name: "Zoyride",
      value: 1,
    },
    {
      name: "Travelogixx (Ezeego1)",
      value: 2,
    },
    {
      name: "CKIS",
      value: 3,
    },
    {
      name: "Europe Car",
      value: 4,
    },
  ];

  forUserList = [
    {
      name: "Direct Customer",
      value: 1,
    },
    {
      name: "B2B Customer",
      value: 2,
    },
    {
      name: "Both Direct and B2B Customer",
      value: 3,
    },
  ];

  get loading() {
    return common.loading;
  }

  async mounted() {
    common.setLoading(true);
    try {
      this.grid = await doGet(this.url);
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async showPage(page) {
    common.setLoading(true);
    this.page = page;
    this.grid = await doGet(this.url + this.filterUrl + "&page=" + page);
    common.setLoading(false);
  }

  async deleteIntegration(integration) {
    common.setLoading(true);
    try {
      await doGet("/api/outlander/config/" + integration._id + "/delete");
      common.showMessage("Deleted Successfully");
      await this.showPage(this.page);
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }
}
